"use strict";

exports.__esModule = true;
var _CurrentPlantTime = require("./CurrentPlantTime");
Object.keys(_CurrentPlantTime).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CurrentPlantTime[key]) return;
  exports[key] = _CurrentPlantTime[key];
});